import BaseRepository from "core/repository/base.repository";
import { PaymentInfoService } from "core/service";
import { PaymentInfoPersistence } from "core/persistence";

class PaymentInfoRepository extends BaseRepository {
  syncable = false;

  resourceName = () => "pagamentos";

  getEntityIdentifier = () => "payment";

  getPersistenceProvider = () => PaymentInfoPersistence;

  getServiceProvider = () => PaymentInfoService;

  async update(params) {
    const currentUser = await this.mRuntime.get("currentUser");
    return await this.mService.update(currentUser.company_uuid, params);
  }

  async deletePaymentInfo() {
    const currentUser = await this.mRuntime.get("currentUser");
    return await this.mService.deletePaymentInfo(currentUser.company_uuid);
  }
}

export default new PaymentInfoRepository();



// WEBPACK FOOTER //
// ./src/core/repository/payment-info.repository.js